// Enums für verschiedene Rollen und ChatPart-Typen
export enum ChatPartType {
    STANDARD = "STANDARD",
    INTERRUPTION = "INTERRUPTION",
    BRANCH = "BRANCH"
};

export enum ChatAccessRoles {
    VIEWER = "VIEWER",
    EDITOR = "EDITOR",
    OWNER = "OWNER"
};

export enum ChatRoles {
    USER = "USER",
    ASSISTANT = "ASSISTANT",
};

// User-Klasse
export class User {
    id: string;
    email: string;
    name?: string;
    chats: Chat[] = [];
    sharedChats: ChatSharing[] = [];
    createdAt: Date;
    updatedAt: Date;

    constructor(id: string, email: string, name?: string) {
        this.id = id;
        this.email = email;
        this.name = name;
        this.createdAt = new Date();
        this.updatedAt = new Date();
    }
}

// Chat-Klasse
export class Chat {
    id: string;
    title?: string;
    userId: string;
    user?: User;
    messages: ChatMessage[] = [];
    sharedWith: ChatSharing[] = [];
    createdAt: Date;
    updatedAt: Date;

    constructor(id: string, user: User, title?: string) {
        this.id = id;
        this.userId = user.id;
        this.user = user;
        this.title = title;
        this.createdAt = new Date();
        this.updatedAt = new Date();
    }
}


// ChatMessage-Klasse
export class ChatMessage {
    id: string;
    role: string = "";
    contents: ChatDataProps[] = [];
    toolData?: Record<string, any>;
    createdAt?: Date;
    updatedAt?: Date;

    constructor(id: string, role: string, contents: ChatDataProps[], toolData?: Record<string, any>) {
        this.id = id;
        this.role = role;
        this.contents = contents;
        this.toolData = toolData;
        this.createdAt = new Date();
        this.updatedAt = new Date();
    }
}

export interface ChatDataProps  {
    type: 'code' | 'video' | 'text' | 'image' | 'pdf' | 'mermaid'; //TODO: type 'plantuml'
    element: string;
    codeClass?:string;
    position: number;
};

// ChatSharing-Klasse
export class ChatSharing {
    id: string;
    chatId: string;
    chat: Chat;
    userId: string;
    user: User;
    role: ChatAccessRoles;
    createdAt: Date;
    updatedAt: Date;

    constructor(id: string, chat: Chat, user: User, role: ChatAccessRoles) {
        this.id = id;
        this.chatId = chat.id;
        this.chat = chat;
        this.userId = user.id;
        this.user = user;
        this.role = role;
        this.createdAt = new Date();
        this.updatedAt = new Date();
    }
}
